"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLocationAwarePurchaseMotionData = exports.fetchPurchaseMotionData = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _memoize = _interopRequireDefault(require("../utilities/memoize"));

var _q = _interopRequireDefault(require("q"));

var fetchPurchaseMotionData = (0, _memoize.default)(function (merchandiseIds) {
  return _apiClient.default.post('/self-service/v2/purchase-motions', {
    data: {
      merchandiseIds: merchandiseIds
    }
  });
});
exports.fetchPurchaseMotionData = fetchPurchaseMotionData;
var fetchLocationAwarePurchaseMotionData = (0, _memoize.default)(function (_ref) {
  var merchandiseIds = _ref.merchandiseIds,
      locations = _ref.locations,
      apiGetter = _ref.apiGetter;

  if (!apiGetter) {
    return _apiClient.default.get('/self-service/v2/purchase-motions', {
      query: {
        merchandiseIds: merchandiseIds,
        location: locations
      }
    });
  }

  return new _q.default.Promise(function (resolve, reject) {
    apiGetter.whenFinished(function (result) {
      resolve(result);
      window.quickFetch.removeEarlyRequest('purchase-motions');
    });
    apiGetter.onError(function (err) {
      reject(err);
      window.quickFetch.removeEarlyRequest('purchase-motions');
    });
  });
});
exports.fetchLocationAwarePurchaseMotionData = fetchLocationAwarePurchaseMotionData;